import * as _ from 'lodash';

export function isJsonLogType(logObject) {
    let isJson = logObject.type === 'json';

    if (isJson) {
        try {
            const parsedObj = JSON.parse(logObject.value);

            if (_.isString(logObject.value) && (logObject.value.indexOf('{') === -1 && logObject.value.indexOf('[') === -1)) {
                isJson = false;
            }

        } catch (e) {
            isJson = false;
        }
    }

    return isJson;
}
